import { render, staticRenderFns } from "./AdminUser.vue?vue&type=template&id=40d151cd&scoped=true&"
import script from "./AdminUser.vue?vue&type=script&lang=js&"
export * from "./AdminUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d151cd",
  null
  
)

export default component.exports